import type { OrderPodAttemptsResponse, OrderPodResponse } from "../types/api.js";
import { apiRequest } from "./api-client.js";

export async function fetchOrderPod(token: string, orderId: string): Promise<OrderPodResponse> {
  return apiRequest<OrderPodResponse>(`/api/v1/orders/${orderId}/pod`, { method: "GET", token });
}

export async function fetchOrderPodAttempts(token: string, orderId: string): Promise<OrderPodAttemptsResponse> {
  return apiRequest<OrderPodAttemptsResponse>(`/api/v1/orders/${orderId}/pod/attempts`, { method: "GET", token });
}

export async function createOrderPod(
  token: string,
  orderId: string,
  body: {
    recordedAt?: string | null;
    receiverName?: string | null;
    deliveryReference?: string | null;
    notes?: string | null;
    confirmationType?: "verbal" | "manual" | "system";
    isAccepted: boolean;
    shipmentId?: string | null;
    receiverDocumentId?: string | null;
    receiverRole?: string | null;
    deliveryOutcome?: "accepted" | "refused" | "partial" | "other" | null;
    acceptanceReason?: string | null;
    evidenceText?: string | null;
    captureNotes?: string | null;
    evidencePhotoUrl?: string | null;
    evidenceSignatureUrl?: string | null;
    capturedLat?: number | null;
    capturedLng?: number | null;
    capturedAccuracyM?: number | null;
    capturedLocationProvider?: string | null;
    capturedLocationAt?: string | null;
    substitutionReason?: string | null;
  },
): Promise<{ pod: import("../types/api.js").ProofOfDelivery }> {
  return apiRequest<{ pod: import("../types/api.js").ProofOfDelivery }>(`/api/v1/orders/${orderId}/pod`, {
    method: "POST",
    token,
    body: { ...body, capturedByChannel: "web" as const },
  });
}

